import { render, staticRenderFns } from "./ReferralDoctorsPage.vue?vue&type=template&id=ec48e114&"
import script from "./ReferralDoctorsPage.vue?vue&type=script&lang=js&"
export * from "./ReferralDoctorsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports